// extracted by mini-css-extract-plugin
export default {"root":"RichListItem_root__XfeJy","clickable":"RichListItem_clickable__x5CM0","anchor":"RichListItem_anchor__ShI2H","content":"RichListItem_content__0GMdr"};